// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

var Utils = {};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetBuyer_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetBuyer_name_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetBuyer_status_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetBuyer_Menu_buyer"
    }
  ],
  "type": "Buyer",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
